import { Component, Input, inject } from '@angular/core';

import { BRAND_CONFIG } from '@shared/services';

// Relative, not via '@shared/components': that barrel re-exports this component's own folder, and
// the resulting cycle leaves AppVersionComponent undefined when the decorator runs.
import { AppVersionComponent } from '../app-version/app-version.component';

@Component({
  selector: 'app-capture-send-footer',
  templateUrl: './capture-send-footer.component.html',
  styleUrls: ['./capture-send-footer.component.scss'],
  imports: [AppVersionComponent],
  standalone: true,
})
export class CaptureSendFooterComponent {
  @Input() businessName!: string;

  readonly brand = inject(BRAND_CONFIG);
}
